import {
  JackpotNormalizedGamesType,
  JackpotNormalizedGameType
} from '../../../types';
import { IInHouseJackpotsState, useInHouseJackpotsStore } from '../../store';

export const selectGameById = (
  games: JackpotNormalizedGamesType,
  launchGameId: string
) => games[launchGameId] || {};

export const useGetGameByLaunchGameId = (
  launchGameId: string
): JackpotNormalizedGameType =>
  useInHouseJackpotsStore(({ games }: IInHouseJackpotsState) =>
    selectGameById(games, launchGameId)
  );
